module.exports = "<main id=\"center-panel\" class=\"shop-centerPanel\" tabindex=\"-1\">\r\n    <oly-dynamic-content oly-dc-global-schedule class=\"dynamic-content2-panelTopGlobal\"></oly-dynamic-content>\r\n\r\n    <oly-dynamic-content oly-dc-url-schedule class=\"dynamic-content2-panelTop\"></oly-dynamic-content>\r\n\r\n    <div ui-view=\"center-panel\"></div>\r\n\r\n    <oly-dynamic-content oly-dc-url-schedule=\"bottom\" class=\"dynamic-content2-panelBottom\"></oly-dynamic-content>\r\n</main>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/views/center-panel.view.html
// module id = 17
// module chunks = 0